export default __webpack_public_path__ + "img/3684e51cff4836b4c8cc8d6b0e981346.png";